import { useCallback } from 'react';
import { Typography } from '@mui/material';
import { format } from 'date-fns';
import { useNavigate } from 'react-router';

import { CategoryIcon } from 'modules/notifications/components/CategoryIcon';
import { INotificationMenuProps } from 'modules/notifications/types';
import { notificationsRoutesConfig } from 'domains/notifications/routes';
import { setOpenNotificationDialogId } from 'modules/notifications/utils/openNotificationDialogUtils';

import { useNotificationsStyles } from './useNotificationsStyles';

export const Notification = ({
  category,
  date,
  id,
  isUnread = false,
  onClose,
  text,
  title,
}: INotificationMenuProps) => {
  const { classes } = useNotificationsStyles();
  const navigate = useNavigate();

  const handleClick = useCallback(() => {
    setOpenNotificationDialogId(id);
    navigate(notificationsRoutesConfig.notifications.generatePath());
    onClose();
  }, [navigate, onClose, id]);

  return (
    <div
      className={classes.item}
      role="button"
      tabIndex={0}
      onClick={handleClick}
    >
      <CategoryIcon category={category} isUnread={isUnread} />
      <div className={classes.infoWrapper}>
        <div className={classes.title}>
          <Typography className={classes.titleText} variant="subtitle3">
            {title}
          </Typography>
          <Typography
            color="textSecondary"
            className={classes.date}
            variant="body4"
          >
            {format(new Date(date), 'MMM d Y HH:mm')}
          </Typography>
        </div>
        <Typography component="div" className={classes.text} variant="body3">
          {text}
        </Typography>
      </div>
    </div>
  );
};
